// FT-193 CTR-03: индивидуальный лимит автопродления клиента — число ≥ 0 или null («действует лимит компании»).
// Пустое поле числового ввода отдаёт "" (или null после очистки) — это «нет своего лимита», а не ноль:
// ноль запрещает клиенту уходить в долг и обязан дойти до сервера нулём.
export function periodicCreditLimitValue(raw) {
  if (raw === null || raw === undefined) return null;
  if (typeof raw === "string" && raw.trim() === "") return null;
  const number = Number(raw);
  return Number.isFinite(number) ? number : null;
}
